var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wistia-wrapper"},[_c('div',{class:`wistia_embed wistia_async_${_vm.mediaId}`,staticStyle:{"height":"360px","width":"100%"},attrs:{"id":_vm.playerId}},[_vm._v("   ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }